import $ from 'jquery';

class GroupCourseReport {
	constructor(){

		// Check if it's the group course report page
		if (this.isCourseReport()) {
			// Create course report table
			new CourseReportTable();
		}
	}

	isCourseReport(){
		return $( '#group-course-report-datatable' ).length === 1;
	}
}

class CourseReportTable {
	constructor(){

		this.table = null;

		// Get elements
		this.getElements();

		// Create DataTable
		this.createDataTables();

		// Populate table after the group course is selected
		this.restPopulateTable();


	}

	getElements(){
		// Get elements
		this.$elements = {
			courseReport: $( '#group-course-report-datatable' ),
		}
	}

	createDataTables(){

		let that       = this;
		let columnDefs = [];

		let columnsVisibility = that.$elements.courseReport.data( 'table_columns' )
		columnsVisibility     = columnsVisibility.split( ',' );

		let columns = [
			{
				data: 'user_name',
				targets: 0,
				title: ulgmRestApiSetup.localized.header.user_name,
				visible: columnsVisibility.includes( "user_name" )
			},
			{
				data: 'first_name',
				targets: 1,
				title: ulgmRestApiSetup.localized.header.first_name,
				visible: columnsVisibility.includes( "first_name" )
			},
			{
				data: 'last_name',
				targets: 2,
				title: ulgmRestApiSetup.localized.header.last_name,
				visible: columnsVisibility.includes( "last_name" )
			},
			{
				data: 'user_email',
				targets: 3,
				title: ulgmRestApiSetup.localized.header.user_email,
				visible: columnsVisibility.includes( "user_email" )
			},
			{
				data: 'percent_completed',
				targets: 4,
				title: ulgmRestApiSetup.localized.header.percent_completed,
				visible: columnsVisibility.includes( "percent_completed" )
			},
			{
				data: 'date_completed',
				targets: 5,
				title: ulgmRestApiSetup.localized.header.date_completed,
				visible: columnsVisibility.includes( "date_completed" )
			},
		];

		if (typeof this.getUrlParameter( 'user_id' ) !== 'undefined') {
			columns.push(
				{
					data: 'course_name',
					targets: 6,
					title: ulgmRestApiSetup.localized.header.course_name,
					visible: columnsVisibility.includes( "course_name" )
				},
			);

			if (this.$elements.courseReport.data( 'transcript_page_url' )) {
				columns.push(
					{
						data: 'transcript_page_url',
						targets: 7,
						title: ulgmRestApiSetup.localized.header.transcript_page_url,
						visible: columnsVisibility.includes( "transcript_page_url" )
					},
				);
				columnDefs = [
					{
						// The `data` parameter refers to the data for the cell (defined by the
						// `data` option, which defaults to the column being worked with, in
						// this case `data: 0`.
						"render": function ( data, type, row ){

							if (that.$elements.courseReport.data( 'transcript_page_url' )) {
								return '<a href="' + that.$elements.courseReport.data( 'transcript_page_url' ) + '?user-id=' + row.user_id + '" target="_blank">' + ulgmRestApiSetup.localized.details + '</a>';
							}
							return data;


						},
						targets: 7
					}
				]
			}
		}

		let initComplete = ( settings, d ) => {

			let table = settings.oInstance.api();
			let _this = this;

			var colFilter_container = $( `<div id="${settings.sInstance}-filter-columns" class="dataTables-filter-columns"><input class="dataTables-filter-columns-field" id="${settings.sInstance}-filter-columns-field" type="checkbox"><div class="dataTables-filter-columns__toggle"><label for="${settings.sInstance}-filter-columns-field" data-label-enable="${ulgmRestApiSetup.localized.customizeColumns}" data-label-disable="${ulgmRestApiSetup.localized.hideCustomizeColumns}"></label></div><div class="dataTables-filter-columns__fields"></div></div>` );

			if (settings.oSavedState !== null) {
				jQuery.each( settings.oSavedState.columns, function ( key, value ){

					var title = settings.aoColumns[key].sTitle;
					colFilter_container.find( '.dataTables-filter-columns__fields' ).append( _this.addColumnCourseCheckbox( title, key, value.visible, table ) );

				} );
			} else {
				jQuery.each( settings.aoColumns, function ( key, value ){

					var title = settings.aoColumns[key].sTitle;
					colFilter_container.find( '.dataTables-filter-columns__fields' ).append( _this.addColumnCourseCheckbox( title, key, value.bVisible, table ) );

				} );
			}

			$( colFilter_container ).insertAfter( '#group-course-report-datatable_filter' );


		};

		// User table
		this.table = this.$elements.courseReport.DataTable( {
			stateSave: true,
			initComplete: initComplete,
			dom: '<"uo-groups-datatable-header"B>frt<"uo-groups-datatable-footer"lpi>',
			buttons: [
				{
					extend: 'csv',
					text: ulgmRestApiSetup.localized.buttons.csvExport,
					filename: function (){
						let courseNamePrefix = 'groups-report';
						let $courseId        = $( '#uo-group-report-course' ).val();
						let courseName       = '-' + $( "#uo-group-report-course option:selected" ).text();

						let name = '';
						if (typeof that.getUrlParameter( 'user_id' ) !== 'undefined') {

							name = that.$elements.courseReport.data( 'user_name' );

							if (isNaN( name )) {
								name = '-for-user-' + name;
							} else {
								name = '-for-user-id-' + name;
							}

							return courseNamePrefix + name;

						} else if ('0' === $courseId) {
							return courseNamePrefix;
						}

						return courseNamePrefix + courseName;
					}
				}
			],
			columns: columns,
			"columnDefs": columnDefs,
			language: {
				processing: ulgmRestApiSetup.localized.processing,
				search: '_INPUT_',
				searchPlaceholder: ulgmRestApiSetup.localized.searchPlaceholder,
				lengthMenu: ulgmRestApiSetup.localized.lengthMenu,
				info: ulgmRestApiSetup.localized.info,
				infoEmpty: ulgmRestApiSetup.localized.infoEmpty,
				infoFiltered: ulgmRestApiSetup.localized.infoFiltered,
				infoPostFix: '',
				loadingRecords: ulgmRestApiSetup.localized.loadingRecords,
				zeroRecords: ulgmRestApiSetup.localized.zeroRecords,
				emptyTable: ulgmRestApiSetup.localized.emptyTable,
				paginate: {
					first: ulgmRestApiSetup.localized.paginate.first,
					previous: ulgmRestApiSetup.localized.paginate.previous,
					next: ulgmRestApiSetup.localized.paginate.next,
					last: ulgmRestApiSetup.localized.paginate.last
				},
				aria: {
					sortAscending: ulgmRestApiSetup.localized.sortAscending,
					sortDescending: ulgmRestApiSetup.localized.sortDescending
				}
			}
		} );
	}

	addColumnCourseCheckbox( label, column_key, is_visible, table ){

		var checkbox = jQuery( '<input />', {
			type: 'checkbox',
			id: 'dt_' + column_key,
			value: column_key,
			checked: is_visible
		} );

		checkbox.on( 'change', function ( e ){
			// Get the column API object
			var current_check = jQuery( this ).attr( 'value' );
			var is_checked    = jQuery( this ).is( ':checked' );

			table.columns().every( function ( index ){

				var column = table.column( index );

				// ... do something with data(), or this.nodes(), etc

				if (index == current_check) {
					if (is_checked) {
						// Toggle the visibility
						column.visible( true );
					} else {
						column.visible( false );
					}
				}


			} );

		} );

		var $label = jQuery( '<label/>' ).append( checkbox ).append( label );
		return $label;
	}

	restPopulateTable(){

		let that                                       = this;
		window.ulgmGroupManagement.populateReportTable = function ( data ){

			let courseReport = that.$elements.courseReport.DataTable();

			courseReport.clear();
			courseReport.rows.add( data.user_course_data ); // Add new data
			courseReport.columns.adjust().draw(); // Redraw the DataTable

			var items = window.ulgmGroupManagement.reportingTemplating.items = data.user_course_data;

			if (0 === items.length) {
				$( '#test' ).html( '<div class="uo-row uo-jplist-row uo-table-content uo-tbl-item body-row"><div class="uo-table-no-results">There are no records to display.</div></div>' );
			} else {
				$( '#test' ).closest( '.uo-groups-rest-result' ).show();
				window.ulgmGroupManagement.reportingTemplating.setItems( items );
			}
		};
	}

	getUrlParameter( sParam ){
		let sPageURL      = window.location.search.substring( 1 ),
			sURLVariables = sPageURL.split( '&' ),
			sParameterName,
			i;

		for (i = 0; i < sURLVariables.length; i++) {
			sParameterName = sURLVariables[i].split( '=' );

			if (sParameterName[0] === sParam) {
				return sParameterName[1] === undefined ? true : decodeURIComponent( sParameterName[1] );
			}
		}
	};
}

export default GroupCourseReport;